// @ts-nocheck
import { forwardRef } from "react";
import { Modal } from "antd";
import { h } from "preact";
import { useEffect, useImperativeHandle, useState } from "preact/hooks";
import BaseForm from "../../../../components/form";
import { useForm } from "react-hook-form";
import { useMessage } from "../../../../hooks/useMessage";
import { POST, RESERVATION_CONFIRM } from "../../../../services";
import { IPropsModal } from "../../interfaces/modal";
import { FORM_EDIT } from "../../constants/form";

const defaultValues = {
  reserveId: "",
  customerName: "",
  customerCode: "",
  createDate: "",
  saleOrder: "",
  invoiceId: "",
  saleLotId: "",
  reserveTypeId: "",
  reserveType: "",
  versionMachine: "",
  exchangeCondition: "",
};

const EditDataForm = (props: IPropsModal, ref) => {
  const { onCallbackEdit } = props;
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [disabledSo, setDisabledSo] = useState(false);
  const { openMessage } = useMessage();
  const { control, setValue, getValues, reset, handleSubmit } = useForm({
    defaultValues,
  });

  useImperativeHandle(ref, () => ({
    async openModal(e) {
      console.log("e", e);
      try {
        if (e.saleOrder) {
          setDisabledSo(true);
        }
        if (e.saleOrder === null) {
          setDisabledSo(false);
        }
        for (const key in e) {
          const element = e[key];
          if (key in defaultValues) {
            setValue(key as keyof typeof defaultValues, element);
          }
        }
        setVisible(true);
      } catch (error) {
        console.log("error", error);
      }
    },
  }));

  useEffect(() => {
    !visible && reset();
  }, [visible]);

  const onConfirm = async () => {
    try {
      setLoading(true);
      const {
        reserveId,
        saleOrder,
        invoiceId,
        saleLotId,
        customerCode,
        reserveTypeId,
      } = getValues();
      const r = await POST(RESERVATION_CONFIRM, {
        reserveId,
        saleOrder,
        invoiceId,
        saleLotId,
        customerCode,
        reserveTypeId,
      });
      if (!r.success) {
        return;
      }
      openMessage("success", r.message);
      setLoading(false);
      onCallbackEdit && onCallbackEdit(getValues());
      setVisible(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
      openMessage("error", error.message);
    }
  };

  return (
    <Modal
      width={700}
      title="แก้ไขข้อมูล"
      visible={visible}
      okText={"บันทึก"}
      cancelText={"ยกเลิก"}
      centered
      onOk={handleSubmit(onConfirm)}
      onCancel={() => setVisible(false)}
      confirmLoading={loading}
    >
      {
        (
          <BaseForm
            control={control}
            forms={FORM_EDIT({ disabledSo })}
            setValue={setValue}
            getValues={getValues}
          />
        ) as React.ReactNode
      }
    </Modal>
  );
};

export const EditData = forwardRef<any, IPropsModal>(EditDataForm);
